import * as React from "react";
import { PaymentMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
export const incomePaymentDetailsLabels = {
    needToProvideAnIncome: "Does this pension need to provide an income?",
    taxableIncomeRequiredInAddition: "Is taxable income required in addition to the tax-free lump sum?",
    paymentMethod: "Payment method",
    bankDetailsHeader: "Bank details",
    expectedGadMaximum: "Expected GAD maximum",
    targetSpecificArrangements: "Do you wish to target specific arrangements?",
    targetSpecificArrangementsTooltip: "Where a customer has more than one drawdown arrangement, you are able to choose which arrangements are used to provide income withdrawals. Selecting specific arrangements can be beneficial for clients who have inherited drawdown benefits which have different tax treatments. Or you can select 'No' and the platform will automatically choose the arrangements to be used.",
    takeDifferentInitialIncomePaymentTooltip: "We offer a different initial income payment; this could be used to take a one-off taxable withdrawal or an alternative first payment followed by a regular income payment of a different amount.",
    maximumIncomePerPayment: "Maximum income per payment",
    maximumAvailablePerPayment: "Maximum available per payment",
    incomeFrequency: "Income frequency",
    firstPaymentDate: "First payment date",
    endDate: "End date",
    untilNotified: "Until notified",
    enterADate: "Enter a date",
    calculateEstimatedPaye: "Calculate estimated PAYE",
    estimatedPayeTax: "Estimated PAYE tax",
    estimatedNetPayment: "Estimated net payment",
    taxCode: "Tax Code",
    taxBasis: "Basis",
    pensionYearEndDate: "Income year-end date",
    totalPostRetirementAccountValue: "Total post-retirement arrangement value",
    from: "From",
    amount: "Amount",
    type: "Type",
    member: "Member",
    gadMaximum: "GAD maximum",
    incomeTakenToDate: "Income taken to date",
    lastMandatoryReview: "Last mandatory review",
    maximumIncomePaymentForRemainderOfYear: "Maximum income payment for remainder of pension year",
    maximumIncomePaymentForFutureYears: "Maximum income payment for future pension years",
    incomePerPaymentForCurrentPensionYear: "Income per payment for current pension year",
    incomePerPaymentForFuturePensionYears: "Income per payment for future pension years",
    MaximumIncomePerPayment: "Maximum income payment per payment",
    incomePerPayment: "Income per payment",
    clientAge: "Client age",
    flexiArrangementsExhausted: "Please tick to confirm your client understands this and is happy to proceed",
    incomeRequired: "Does this pension need to provide an income?",
    sumOfValueToSell: "Percentage of income payment (total)",
    selectBankAccount: "Select bank account",
    splitAcrossTwoBankAccounts: "Split across two bank accounts",
    bankAccount1: "Bank account 1",
    bankAccount2: "Bank account 2",
    addBankAccount: "Add bank account",
    portionOfPcls: "Portion of PCLS",
    proportionOfIncome: "Proportion of income",
    capped: "Capped",
    inherited: "Inherited",
    nextYearsGadMaximum: "Next years GAD Maximum",
    nextFlexiReviewDate: "Next flexible income review date",
    frequencyOfFlexiIncomeReview: "Frequency of flexible income review",
    cappedPlusFlexiTotals: "Capped plus flexible totals",
    takeDifferentInitialIncomePayment: "Do you wish to take a different initial income payment?",
    grossInitialIncomePayment: "Gross initial income payment",
    maximumInitialIncomePayment: "Maximum for initial income payment",
    grossIncomePerPayment: "Gross income per payment",
    grossIncomePerPaymentFromPension: "Gross income per payment from the pension",
    crystallisation: "Drawdown",
    wrapCash: "Cash account",
    totalPortionOfPCLSNot100: "Total portion of PCLS must be 100%",
    totalProportionOfIncomeNot100: "Total proportion of income must be 100%",
    bankAccountNotValidated:
        "Please note this bank account is not validated - it must have been validated by the time we do the drawdown.",
    clientPensionBenifits:"Is your client taking pension benefits as part of new business?",
    clientOptedOut:"Has the client opted out, or declined to join, a pension where their employer will contribute?"
};

export const incomePaymentDetailsMessages = {
    grossIncomePerPaymentRequired: "Please enter gross income per payment",
    incomeFrequencyRequired: "Please enter income frequency",
    firstPaymentDateRequired: "Please enter first payment date",
    enterADateRequired: "Please enter a date",
    flexiArrangementsExhausted:
        "The income specified will exhaust one or more of your client's flexible drawdown arrangements within a year.",
    messagesGrossInitialIncomeOver: "Gross initial income payment must not be greater than maximum",
    grossIncomePerPaymentOver:
        "Please enter an income amount that is greater than zero and less than or equal to the maximum income per payment.",
    firstPaymentDateUnder15: "The date selected must be at least 15 working days from today",
    firstPaymentDateUnder10: "The date selected must be at least 10 working days from today",
    endDateUnder: "End date must be equal to or later than the first payment date",
    dateOver28: "Date must also be between 1-28 of any month",
    standardAlgorithmCappedMessage:
        "Where income is being taken from Capped drawdown, the amount available will be subject to the maximum annual limits. The maximum income may be less than shown where drawdown benefits have been transferred to the Aberdeen SIPP and withdrawals have been taken from the previous scheme.",
    inheritedFundMessage:
        "This Aberdeen SIPP plan includes an inherited drawdown arrangement(s). Remember, you can use the ‘target specific arrangements’ option should you wish to include or exclude these arrangements when making withdrawals.",
    percentageOver100: "value can't exceed 100%",
    percentageUnder0: "At least 0%",
    not100PercentMessage:
        "Please enter values against the assets from which the income payment will be made that total 100%",
    cannotBeGreaterThanMaximumIncomePaymentForRemainderOfYear:
        "Income per payment for current pension year cannot be more than the maximum",
    cannotBeGreaterThanMaximumIncomePaymentForFutureYears:
        "Income per payment for future pension years cannot be more than the maximum",
    cannotBeGreaterThanMaximumPerIncomePayment: "Income per payment cannot be more than maximum",
    nextFlexiReviewDateRequired: "Please enter next flexible income review date",
    nextFlexiReviewDateUnder: "Date must be 20 days or more in the future",
    frequencyOfFlexiIncomeReviewUnderOver: "Frequency must be between 1 and 60",
    totalPortionOfPCLSNot100: "Total portion of PCLS must be 100%",
    totalProportionOfIncomeNot100: "Total proportion of income must be 100%",
    incomePerPaymentForCurrentPensionYearRequired: "Please enter income per payment for current pension year",
    incomePerPaymentForFuturePensionYearsRequired: "Please enter income per payment for future pension years",
    grossIncomeNotSumOfArrangementsIncome: "Total of arrangements income must equal gross income",
    confirmIncomeReviewDate: "Income review date is more than 3 years in the future.  Please confirm this is correct",
};

export enum IncomeArrangementType {
    Capped,
    Flexi,
}

export const IncomeArrangementTypeMaps = {
    [IncomeArrangementType.Capped]: "Capped",
    [IncomeArrangementType.Flexi]: "Flexible",
};

export const IncomePaymentMethodMap = {
    [PaymentMethod.Faster]: "FASTER/CHAPS",
    [PaymentMethod.Bacs]: "BACS",
};

export const IncomePaymentMethodOptions = [PaymentMethod.Faster, PaymentMethod.Bacs];
